import React from 'react';

import * as S from './ShareProperties.styles';
import IconSelector from '@ibibo/icon-selector';

const ShareHotelPreview = ({modalData}) => {

  
  let sliderLeft = 0;
  const slideLeft = () => {
    let leftSlide = document.getElementById('cardList');
    let leftArrow = document.getElementById('leftArrow');
    let rightArrow = document.getElementById('rightArrow');
    let blockWidth = leftSlide.offsetWidth;
    if(sliderLeft < (blockWidth - 720)){
      sliderLeft = sliderLeft + 360;
      rightArrow.style.opacity = '1';
      rightArrow.style.pointerEvents = '';
      rightArrow.style.cursor = 'pointer';
    }else{
      leftArrow.style.opacity = '0.5';
      leftArrow.style.pointerEvents = 'none';
      leftArrow.style.cursor = 'default';
    }
    leftSlide.style.transform = `translateX(-${sliderLeft}px)`;
  }

  const slideRight = () => {
    let leftSlide = document.getElementById('cardList');
    let leftArrow = document.getElementById('leftArrow');
    let rightArrow = document.getElementById('rightArrow');
    if(sliderLeft > 0){
      sliderLeft = sliderLeft - 360;
      leftArrow.style.opacity = '1';
      leftArrow.style.pointerEvents = '';
      leftArrow.style.cursor = 'cursor';
    }else{
      rightArrow.style.opacity = '0.5';
      rightArrow.style.pointerEvents = 'none';
      rightArrow.style.cursor = 'default';
    }
    leftSlide.style.transform = `translateX(-${sliderLeft}px)`;
  }

  return (
    <div style={{flexDirection: 'column', display: 'flex', width: '100%'}}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <a style={{width: '3rem', height: '3rem', borderRadius: '50%', border: '1px solid #e5e5e5', display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => slideRight()} href="javascript: void(0);" id="rightArrow">
          <IconSelector iconKey="leftarrow" props={{width: '1rem', height: '1rem', fill: '#008cff' }}/>
        </a>
        <a style={{width: '3rem', height: '3rem', borderRadius: '50%', border: '1px solid #e5e5e5', marginLeft: '20px',  display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => slideLeft()} id="leftArrow" href="javascript: void(0);">
          <IconSelector iconKey="rightarrow" props={{width: '1rem', height: '1rem', fill: '#008cff' }}/>
        </a>
      </div>
      <div style={{width: '100%', overflow: 'auto'}} dangerouslySetInnerHTML={{
        __html: modalData,
      }} />

    </div>
    
  );
};

export default ShareHotelPreview;
